import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getPerformance } from 'firebase/performance'

const firebaseConfig = {
  apiKey: 'AIzaSyC-jG2jmtKrjgdFIjADJ_HVSm_yOxxlEOE',
  authDomain: 'asiapay-checkout-counter.firebaseapp.com',
  projectId: 'asiapay-checkout-counter',
  storageBucket: 'asiapay-checkout-counter.firebasestorage.app',
  messagingSenderId: '277150886572',
  appId: '1:277150886572:web:4fb96bd405a1bbb3804d09',
  measurementId: 'G-FJZDVHPNEV',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const analytics = getAnalytics(app)
window.analytics = analytics
const perf = getPerformance(app)
window.perf = perf
